import { render, staticRenderFns } from "./ButtonElement.vue?vue&type=template&id=783c8f73&"
import script from "./ButtonElement.vue?vue&type=script&lang=js&"
export * from "./ButtonElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports